(() => {
  const root = document.documentElement;
  const HEADER_SELECTOR = '#header-component, header-component, .header';
  const HEADER_MENU_CLASSES = ['menu-open', 'submenu-open', 'sublist-open'];

  const getHeaderOffset = () => {
    const header = document.querySelector(HEADER_SELECTOR);
    const bodyStyles = window.getComputedStyle(document.body);
    const bodyHeaderHeight = parseFloat(bodyStyles.getPropertyValue('--header-height')) || 0;
    const headerBottom = parseFloat(window.getComputedStyle(root).getPropertyValue('--qbs-header-bottom')) || 0;
    const headerRectHeight = header instanceof HTMLElement ? header.getBoundingClientRect().height : 0;

    return Math.max(bodyHeaderHeight, headerBottom, headerRectHeight, 0);
  };

  const closeHeaderOverlays = () => {
    HEADER_MENU_CLASSES.forEach((className) => root.classList.remove(className));

    document.querySelectorAll('[data-submenu]._active-submenu').forEach((item) => {
      item.classList.remove('_active-submenu');
    });

    document.querySelectorAll('[data-parent]._active-submenu').forEach((item) => {
      item.classList.remove('_active-submenu');
    });

    document.querySelectorAll('[data-sublist]._active-sublist').forEach((item) => {
      item.classList.remove('_active-sublist');
    });

    document.querySelectorAll('[data-sublist-parent]._active-sublist').forEach((item) => {
      item.classList.remove('_active-sublist');
    });

    if (!document.querySelector('.popup_show')) {
      root.classList.remove('popup-show');
      root.classList.remove('lock');
      document.body.style.paddingRight = '';
    }
  };

  const scrollToHash = (hash, updateHistory = true) => {
    if (!hash || hash === '#') return false;

    const target = document.querySelector(hash);
    if (!(target instanceof HTMLElement)) return false;

    closeHeaderOverlays();

    const top = window.scrollY + target.getBoundingClientRect().top - getHeaderOffset();

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: 'smooth',
    });

    if (updateHistory) {
      window.history.pushState(null, '', hash);
    }

    return true;
  };

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[data-anchor-scroll][href^="#"]');
    if (!(anchor instanceof HTMLAnchorElement)) return;

    const href = anchor.getAttribute('href') || '';
    if (!href.startsWith('#') || href === '#') return;

    if (!document.querySelector(href)) return;

    event.preventDefault();
    scrollToHash(href);
  });
})();
